var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Banner',
        to: '/banner'
      }, {
        label: 'Add New'
      }],
      "title": "New Banner"
    }
  }), _c('div', {
    staticClass: "bg-white py-2.5 rounded-lg shadow-sm mb-4"
  }, [_c('div', {
    staticClass: "flex-col justify-between py-0 mx-4 pb-4 border-b"
  }, [_c('h4', {
    staticClass: "font-bold text-xl leading-7 mb-4 block"
  }, [_vm._v("Create New Banner")]), _vm._m(0), _c('div', {
    staticClass: "grid grid-cols-2 gap-14"
  }, [_c('div', {
    staticClass: "..."
  }, [_c('div', [_c('label', {
    staticClass: "block mt-0 mb-2 font-medium text-gray-700"
  }, [_vm._v("Banner Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.name,
      expression: "form.name"
    }],
    class: ['w-full rounded-md px-3 py-2.5 mb-1 text-sm focus:outline-none focus:ring-2', _vm.submitted && !_vm.form.name ? 'bg-red-300 focus:ring-red-500 border-red-500 placeholder-red-500' : 'border-gray-300 bg-gray-50 '],
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Enter Banner Name"
    },
    domProps: {
      "value": _vm.form.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value);
      }
    }
  }), _vm.submitted && !_vm.form.name ? _c('p', {
    staticClass: "text-red-500 text-sm mt-0"
  }, [_vm._v("Must be filled.")]) : _vm._e()]), _c('div', {
    staticClass: "grid grid-cols-1 gap-2 my-2"
  }, [_c('div', {}, [_c('label', {
    staticClass: "block mb-0 font-medium text-gray-700"
  }, [_vm._v("Start Date")]), _c('DatetimeCustom', {
    staticClass: "mt-0 relative -top-2 w-full mr-1.5",
    attrs: {
      "timeDate": true,
      "label": ''
    },
    model: {
      value: _vm.form.valid_from,
      callback: function ($$v) {
        _vm.$set(_vm.form, "valid_from", $$v);
      },
      expression: "form.valid_from"
    }
  })], 1), _c('div', {}, [_c('label', {
    staticClass: "block mb-0 font-medium text-gray-700"
  }, [_vm._v("End Date")]), _c('DatetimeCustom', {
    staticClass: "mt-0 w-full relative -top-2 mr-1.5",
    attrs: {
      "timeDate": true,
      "label": ''
    },
    model: {
      value: _vm.form.valid_to,
      callback: function ($$v) {
        _vm.$set(_vm.form, "valid_to", $$v);
      },
      expression: "form.valid_to"
    }
  })], 1)]), _c('div', {
    staticClass: "mt-0"
  }, [_c('label', {
    staticClass: "block mb-2 font-medium text-gray-700"
  }, [_vm._v("Platform")]), _c('ContentSelect', {
    staticClass: "bg-gray-50",
    attrs: {
      "options": _vm.platforms,
      "isError": _vm.platformValidate,
      "defaultText": 'Select Platform'
    },
    model: {
      value: _vm.form.platform,
      callback: function ($$v) {
        _vm.$set(_vm.form, "platform", $$v);
      },
      expression: "form.platform"
    }
  }), _vm.platformValidate ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v("Must be filled.")]) : _vm._e()], 1)]), _c('div', {
    staticClass: "..."
  }, [_c('label', {
    staticClass: "block mb-2 font-medium text-gray-700"
  }, [_vm._v("Banner Image")]), _c('div', {
    staticClass: "relative w-72 h-36 border-2 border-dashed bg-gray-100 border-gray-300 rounded-lg flex items-center justify-center cursor-pointer hover:bg-gray-50",
    class: _vm.imageValidate && !_vm.form.file && 'bg-red-300 border-red-300',
    on: {
      "click": _vm.triggerFileUpload
    }
  }, [_c('input', {
    ref: "fileInput",
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handleFileChange
    }
  }), this.imageFile ? _c('div', {
    staticClass: "absolute inset-0"
  }, [_c('img', {
    staticClass: "object-cover w-full h-full rounded-lg",
    attrs: {
      "src": this.imageFile,
      "alt": "Author Image"
    }
  }), _c('button', {
    staticClass: "absolute top-1 right-1 bg-white text-red-500 rounded-full h-6 w-6 hover:bg-gray-100",
    attrs: {
      "title": "Remove image"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.removeImage.apply(null, arguments);
      }
    }
  }, [_vm._v(" ✕ ")])]) : _c('div', {
    staticClass: "flex justify-center flex-col text-center align-middle items-center text-gray-400"
  }, [_c('svg', {
    staticClass: "w-6 h-6 text-gray-500 text-center dark:text-white",
    class: _vm.imageValidate && !_vm.form.file && 'text-red-500',
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "20",
      "fill": "currentColor",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M9 7V2.221a2 2 0 0 0-.5.365L4.586 6.5a2 2 0 0 0-.365.5H9Zm2 0V2h7a2 2 0 0 1 2 2v6.41A7.5 7.5 0 1 0 10.5 22H6a2 2 0 0 1-2-2V9h5a2 2 0 0 0 2-2Z",
      "clip-rule": "evenodd"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M9 16a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm6-3a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z",
      "clip-rule": "evenodd"
    }
  })]), _c('p', {
    staticClass: "text-sm text-gray-500 m-0",
    class: _vm.imageValidate && !_vm.form.file && 'text-red-500'
  }, [_vm._v("Upload Image")]), _c('p', {
    staticClass: "text-xs text-gray-400 m-0",
    class: _vm.imageValidate && !_vm.form.file && 'text-red-500'
  }, [_vm._v("Max 2MB")])])]), _vm.errorMessageFile ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v(_vm._s(_vm.errorMessageFile))]) : _vm._e(), _vm.submitted && !_vm.form.file ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v("Must be filled.")]) : _vm._e()])])]), _c('div', {
    staticClass: "flex-col justify-between py-0 mx-4 pb-4"
  }, [_c('h4', {
    staticClass: "font-bold text-xl leading-7 my-4 px-0 block"
  }, [_vm._v("Detail")]), _c('div', {
    staticClass: "grid grid-cols-2 gap-14"
  }, [_c('div', {
    staticClass: "w-full"
  }, [_c('div', {
    staticClass: "grid grid-cols-2 gap-4"
  }, [_c('div', [_c('label', {
    staticClass: "block mb-2 font-medium text-gray-700"
  }, [_vm._v("Banner Type")]), _c('ContentSelect', {
    staticClass: "bg-gray-50",
    attrs: {
      "options": _vm.bannerTypes,
      "defaultText": 'Enter Banner Type',
      "isError": _vm.bannerTypeValidate
    },
    model: {
      value: _vm.form.bannerType,
      callback: function ($$v) {
        _vm.$set(_vm.form, "bannerType", $$v);
      },
      expression: "form.bannerType"
    }
  }), _vm.submitted && !_vm.form.bannerType ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v("Must be filled.")]) : _vm._e()], 1), _c('div', [_c('label', {
    staticClass: "block mb-2 font-medium text-gray-700"
  }, [_vm._v("Display Zone")]), _c('ContentSelect', {
    staticClass: "bg-gray-50",
    attrs: {
      "options": _vm.displayZones,
      "defaultText": 'Enter Display Zone',
      "isError": _vm.displayZoneValidate
    },
    model: {
      value: _vm.form.displayZone,
      callback: function ($$v) {
        _vm.$set(_vm.form, "displayZone", $$v);
      },
      expression: "form.displayZone"
    }
  }), _vm.submitted && !_vm.form.displayZone ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v("Must be filled.")]) : _vm._e()], 1), _c('div', [_c('label', {
    staticClass: "block mb-2 font-medium text-gray-700"
  }, [_vm._v("Display Price")]), _c('ContentSelect', {
    staticClass: "bg-gray-50",
    attrs: {
      "options": _vm.displayPrices,
      "defaultText": 'Enter Display Price',
      "isError": _vm.displayPriceValidate
    },
    model: {
      value: _vm.form.displayPrice,
      callback: function ($$v) {
        _vm.$set(_vm.form, "displayPrice", $$v);
      },
      expression: "form.displayPrice"
    }
  }), _vm.submitted && !_vm.form.displayPrice ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v("Must be filled.")]) : _vm._e()], 1), _c('div', [_c('label', {
    staticClass: "block mb-2 font-medium text-gray-700"
  }, [_vm._v("Sort Priority")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.sortPriority,
      expression: "form.sortPriority"
    }],
    class: ['w-full rounded-md px-3 py-2.5 mb-0 border-gray-300 text-sm focus:outline-none bg-gray-50 focus:ring-2', _vm.submitted && !_vm.form.sortPriority ? 'bg-red-300 focus:ring-red-500 border-red-500 placeholder-red-500 mb-0' : 'border-gray-300 bg-gray-50 '],
    attrs: {
      "id": "sort_priority",
      "type": "number",
      "placeholder": "Enter Sort Priority",
      "min": 10,
      "max": 5000
    },
    domProps: {
      "value": _vm.form.sortPriority
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "sortPriority", $event.target.value);
      }
    }
  }), _vm.submitted && !_vm.form.sortPriority ? _c('p', {
    staticClass: "text-red-500 text-sm my-1"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('p', {
    staticClass: "text-gray-500 text-sm mt-1"
  }, [_vm._v("*Please input between 10 - 50000")])])]), _c('div', {
    staticClass: "flex-col w-full"
  }, [_c('label', {
    staticClass: "block mb-2 font-medium text-gray-700"
  }, [_vm._v("Banner Terms and Condition")]), _c('t-textarea', {
    staticClass: "rounded-lg mb-4 text-gray-500",
    attrs: {
      "type": "number",
      "placeholder": "Type banner terms and condition..."
    },
    model: {
      value: _vm.form.termCondition,
      callback: function ($$v) {
        _vm.$set(_vm.form, "termCondition", $$v);
      },
      expression: "form.termCondition"
    }
  })], 1)]), _c('div', {
    staticClass: "w-full"
  }, [_c('div', {
    staticClass: "flex-col w-full mb-3 mr-3"
  }, [_c('label', {
    staticClass: "block mb-2 font-medium text-gray-700"
  }, [_vm._v("Campaign")]), _vm.form.bannerType == 'open url' ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.payload,
      expression: "form.payload"
    }],
    class: ['w-full bg-gray-50 rounded-md  border-gray-300 px-4 py-2.5 mb-2 text-sm focus:outline-none focus:ring-2'],
    attrs: {
      "id": "banner-Playload",
      "type": "text",
      "placeholder": "Enter Banner Payload",
      "required": ""
    },
    domProps: {
      "value": _vm.form.payload
    },
    on: {
      "change": function ($event) {
        _vm.form.campaign = '';
      },
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "payload", $event.target.value);
      }
    }
  })]) : _c('div', {
    staticClass: "mr-1"
  }, [_c('multiselect', {
    staticClass: "custom-multiselect",
    class: {
      'error': _vm.submitted && !_vm.form.campaign
    },
    attrs: {
      "placeholder": "Select Campaign",
      "open-direction": "bottom",
      "label": "name",
      "track-by": "name",
      "options": _vm.campaignSearchOptions,
      "loading": _vm.isCampaignSearch,
      "searchable": true,
      "close-on-select": true,
      "options-limit": 10,
      "multiple": false,
      "required": ""
    },
    on: {
      "search-change": _vm.campaignFind
    },
    scopedSlots: _vm._u([{
      key: "singleLabel",
      fn: function (_ref) {
        var option = _ref.option;
        return [_c('div', {
          staticClass: "text-sm font-medium text-gray-500 px-2"
        }, [_vm._v(" " + _vm._s(option.name) + " ")])];
      }
    }, {
      key: "caret",
      fn: function () {
        return [_c('svg', {
          staticClass: "w-5 h-5 text-gray-500 absolute right-5 top-2.5",
          attrs: {
            "fill": "none",
            "stroke": "currentColor",
            "stroke-width": "2",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "d": "M19 9l-7 7-7-7"
          }
        })])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form.campaign,
      callback: function ($$v) {
        _vm.$set(_vm.form, "campaign", $$v);
      },
      expression: "form.campaign"
    }
  }), _vm.submitted && !_vm.form.campaign ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1"
  }, [_vm._v("Must be filled.")]) : _vm._e()], 1)]), _c('div', {
    staticClass: "grid grid-cols-1 gap-2"
  }, [_c('div', {}, [_c('label', {
    staticClass: "block mb-2 font-medium text-gray-700"
  }, [_vm._v("Notification Title")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.notifation,
      expression: "form.notifation"
    }],
    class: ['w-full rounded-md px-3 py-2.5 mb-2 border-gray-300 text-sm focus:outline-none bg-gray-50 focus:ring-2'],
    attrs: {
      "id": "notifation",
      "type": "text",
      "placeholder": "Enter Notification Title"
    },
    domProps: {
      "value": _vm.form.notifation
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "notifation", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "mb-2"
  }, [_c('label', {
    staticClass: "block mb-2 font-medium text-gray-700"
  }, [_vm._v("Notification Display Date")]), _c('DatetimeCustom', {
    staticClass: "mt-0 w-full relative -top-2 mr-1.5",
    attrs: {
      "timeDate": true,
      "label": ''
    },
    model: {
      value: _vm.form.notifDisplayDate,
      callback: function ($$v) {
        _vm.$set(_vm.form, "notifDisplayDate", $$v);
      },
      expression: "form.notifDisplayDate"
    }
  })], 1)]), _c('div', {
    staticClass: "flex-col w-full mb-0"
  }, [_c('label', {
    staticClass: "block mb-2 font-medium text-gray-700"
  }, [_vm._v("Notification Content")]), _c('t-textarea', {
    staticClass: "rounded-lg mb-4 text-gray-500",
    attrs: {
      "type": "number",
      "placeholder": "Type notification content..."
    },
    model: {
      value: _vm.form.notifContent,
      callback: function ($$v) {
        _vm.$set(_vm.form, "notifContent", $$v);
      },
      expression: "form.notifContent"
    }
  })], 1)])]), _c('div', {
    staticClass: "flex justify-start"
  }, [_c('button', {
    staticClass: "mr-3 text-white bg-blue-700 rounded-lg px-2.5 py-2",
    attrs: {
      "disabled": _vm.isSubmitting,
      "type": "click"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.isSubmitting ? 'Loading...' : 'Save') + " ")]), _c('button', {
    staticClass: "bg-white border-blue-700 border-t border-b border-l border-r text-blue-700 mr-3 rounded-lg px-2.5 py-2",
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Reset Form")]), _c('button', {
    staticClass: "bg-white border text-gray-700 rounded-lg px-2.5 py-2",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/banner');
      }
    }
  }, [_vm._v("Cancel")])])])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-gray-50 border rounded-lg px-4 py-3 mb-8"
  }, [_c('h3', {
    staticClass: "font-semibold text-sm mb-3"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-exclamation mr-1 relative -ml-1"
  }), _vm._v(" Banner Rules")]), _c('ul', {
    staticClass: "list-disc list-inside text-sm text-gray-600 space-y-1 mb-1.5"
  }, [_c('li', [_vm._v("Platform IOS image banner must 2000 × 420 pixels or 1300 × 500 pixels")]), _c('li', [_vm._v("Platform Android image banner must 1300 × 500 pixels")]), _c('li', [_vm._v("Platform WEB image banner must 2100 × 304 pixels")]), _c('li', [_vm._v("Banner Type Promotion Banner image banner must 900 × 450 pixels")]), _c('li', [_vm._v("For Open URL Banner must input Payload and except Open URL Banner must input Campaign")]), _c('li', [_vm._v("Notification date must lower than Valid From")])])]);
}]

export { render, staticRenderFns }